import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/feature/Reveal';

const STEPS = [
  {
    id: 'attach',
    step: '01',
    title: 'Attach it to one chart',
    text: 'Drop the GoldWarden .ex5 file into MetaTrader 5, load the preset for your account size, and drag it onto a single XAUUSD M15 chart. One chart is all it needs.',
  },
  {
    id: 'trade',
    step: '02',
    title: 'It hunts gold for you',
    text: 'The EA scans structure, momentum and volatility during the London and New York sessions, then enters with tight precision when the edge lines up.',
  },
  {
    id: 'manage',
    step: '03',
    title: 'Risk is managed instantly',
    text: 'Every order ships with a hard stop-loss and take-profit attached, and position size is a fixed fraction of equity — no martingale, no grid. Sizing also shrinks automatically into high-impact US news on gold.',
  },
];

export default function HowItWorksPreview() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="How it works"
              title="Five minutes to fully automated gold trading"
              subtitle="No coding, no signal copying, no babysitting the screen. Set it up once and let the algorithm work."
            />
          </Reveal>

          <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
            {STEPS.map((item, index) => (
              <Reveal key={item.id} delay={index * 90} className="h-full">
                <div className="group h-full">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-background-300 font-num text-sm font-semibold tracking-wider text-foreground-700 transition-all duration-200 ease-out group-hover:-translate-y-1 group-hover:border-accent-400 group-hover:text-accent-600">
                    {item.step}
                  </span>

                  <h3 className="mt-5 font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                    {item.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={280}>
            <div className="mt-10 md:mt-12 flex justify-center">
              <Link
                to="/how-it-works"
                className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-900 transition-colors duration-200 hover:border-accent-400 hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                Read the full strategy breakdown
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}